"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const InputLabel_1 = __importDefault(require("../InputLabel"));
require("@hotmart/cosmos/dist/form/form.css");
require("@hotmart/cosmos/dist/form/input-custom.css");
require("@hotmart/cosmos/dist/form/input-radio.css");
const Radio = ({ name, id, label, className = '', ...rest }) => {
    const classes = (0, classnames_1.default)('hot-form hot-form--custom hot-form--radio', className);
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes, children: [(0, jsx_runtime_1.jsx)("input", { ...rest, className: "hot-form__input _border-0", id: id, name: name, type: "radio" }), (0, jsx_runtime_1.jsx)(InputLabel_1.default, { className: "_my-0", htmlFor: id, children: label })] }));
};
exports.default = Radio;
